import { LiaFileDownloadSolid } from "react-icons/lia";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { ActionIconButton } from "../../components/datatable/DataGridActions";

const columnsData = [
  {
    field: "full_name",
    headerName: "Mentor",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    minWidth: 140,
  },
  {
    field: "subject",
    headerName: "Subject",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    minWidth: 140,
  },
  {
    field: "file_path",
    headerName: "File",
    flex: 1,
    minWidth: 80,
    renderCell: (params) => {
      const fileUrl = params.value;
      if (!fileUrl) return <span>No File</span>;

      return (
        <a
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          download
          style={{
            color: "#261134",
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
          title="Download file"
        >
          <LiaFileDownloadSolid size={20} style={{ marginRight: 5 }} />
        </a>
      );
    },
  },
];

let actionHeader = (handleDelete, setOpen, setSelectedRow) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 72,
      maxWidth: 90,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Delete record"
              onClick={() => handleDelete(params.row.id)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
